const buildings = new Map([
  ["100", "Praia dos Anjos"],
  ["200", "Golden Lake"],
  ["300", "Blue Lake"],
]);

export function getBuildingById(id: string) {
  return buildings.get(id);
}
